import React from "react";


function Timing() {
  return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/slider/slider-1.png)',backgroundSize:'cover',backgroundPosition:'center'}}></div>
      <div className="container" style={{backgroundImage:'url(./images/slider/slider-1.png)',marginTop:'100px',marginBottom:'100px',padding:'50px',backgroundSize:'cover',backgroundAttachment:'fixed'}}>
        <div className="row" style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
            <div className="col-md-7" style={{background:'#fffffff7',padding:'50px'}}>
                <div className="row" style={{marginBottom:'50px',borderBottom:'1px solid orange',paddingBottom:'15px',paddingTop:'15px',background:'orange'}}>
                    <div className="col-md-12 middle">
                       <center><p className="enquiry">Darshan Timings / ദർശന സമയം</p> </center>                                         
                    </div>
                </div>
                <div className="row" style={{marginBottom:'50px',paddingBottom:'15px',paddingTop:'15px'}}>
                    {/* <center>
                          <h3 className="theading" style={{fontSize:'20px',fontWeight:'700',marginTop:'-20px',textAlign:'center'}}>Alpashi Festival from 16-10-2025 to 31-10-2025</h3>
                      </center> */}
                    {/* first */}
                   
                    <div class="row col-md-12">
                        <div className="col-md-12 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                        <table className="table">
                            <tr>
                                <td className="timelist">പള്ളിയുണർത്തൽ</td>
                                <td className="timelist">04:00 ന്</td>
                            </tr>
                            <tr>
                                <td className="timelist">നടതുറക്കൽ</td>
                                <td className="timelist">05:00 ന്</td>
                            </tr>
                            <tr>
                                <td className="timelist">അഭിഷേകം</td>
                                <td className="timelist">05:15 ന്</td>
                            </tr>
                             <tr>
                                <td className="timelist">ഗണപതിഹോമം</td>
                                <td className="timelist">06:15 ന്</td>
                            </tr>
                             <tr>
                                <td className="timelist">ഉഷ:പൂജ</td>
                                <td className="timelist">07:30 ന്</td>
                            </tr>
                             <tr>
                                <td className="timelist">നടയടയ്ക്കുന്നത്</td>
                                <td className="timelist">10:30 ന്</td>
                            </tr>
                        </table>
                            {/* <ul>
                                <li className="timelist">3:30 AM to 4:45 AM</li>
                                <li className="timelist">6:30 AM to 7:00 AM</li>
                                <li className="timelist">08:30 AM to 10:00 AM</li>
                                <li className="timelist">10:30 AM to 11:15 AM</li>
                                <li className="timelist">After 12:00</li>
                          </ul> */}
                         </div>
                        <div className="col-md-12 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <table className="table">
                            <tr>
                                <td className="timelist">നട തുറക്കുന്നത്</td>
                                <td className="timelist">05:30 ന്</td>
                            </tr>
                            <tr>
                                <td className="timelist">ദീപാരാധന</td>
                                <td className="timelist">06:30 ന്</td>
                            </tr>
                            <tr>
                                <td className="timelist">അത്താഴപൂജ</td>
                                <td className="timelist">07:30 ന്</td>
                            </tr>
                             <tr>
                                <td className="timelist">നടയടയ്ക്കുന്നത്</td>
                                <td className="timelist">08:00 ന്</td>
                            </tr>
                            
                        </table>

                               
                                {/* <ul>
                                    <li className="timelist">4:30 PM to 6:15 PM</li>
                                    <li className="timelist">6:45 PM to 7:20 PM</li>
                                    <li className="timelist">After Sreeveli</li>
                                </ul> */}
                      </div>
                    </div>
                     {/* <div className="timedate">
                        <h5>16.10.2025  (പ്രാസാദ ശുദ്ധി)</h5>
                       </div>
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                            <ul>
                                <li className="timelist">3:30 AM to 4:45 AM</li>
                                <li className="timelist">6:30 AM to 7:00 AM</li>
                                <li className="timelist">08:30 AM to 10:00 AM</li>
                                <li className="timelist">10:30 AM to 11:15 AM</li>
                                <li className="timelist">11:45 AM to 12:00 AM</li>
                          </ul>
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <ul>
                                 <li className="timelist">4:30 PM to 6:00 PM</li>
                                </ul>
                      </div>
                    </div>

                     <div className="timedate">
                        <h5>17.10.2025  (ചതു. ശുദ്ധി, ധാര)</h5>
                       </div>
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                            <ul>
                                <li className="timelist">3:30 AM to 4:45 AM</li>
                                <li className="timelist">6:30 AM to 7:00 AM</li>
                                <li className="timelist">After 10:30 AM</li>
                                
                          </ul>
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <ul>
                                 <li className="timelist">4:30 PM to 6:15 PM</li>
                                 <li className="timelist">6:45 PM to 7:20 PM</li>
                                </ul>
                      </div>
                    </div>  
                    <div className="timedate">
                        <h5>18.10.2025  (ബിംബ ശുദ്ധി)</h5>
                       </div>
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                            <ul>
                                <li className="timelist">3:30 AM to 4:45 AM</li>
                                <li className="timelist">6:30 AM to 7:00 AM</li>
                                <li className="timelist">After 10:30 AM</li>
                                
                          </ul>
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <ul>
                                 <li className="timelist">4:30 PM to 6:15 PM</li>
                                 <li className="timelist">6:45 PM to 7:20 PM</li>
                                </ul>
                      </div>
                    </div>  
                    <div className="timedate">
                        <h5>19.10.2025  (തത്വ ഹോമം)</h5>
                       </div>
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                            <ul>
                                <li className="timelist">3:30 AM to 4:45 AM</li>
                                <li className="timelist">6:30 AM to 7:00 AM</li>
                                <li className="timelist">After 10:30 AM</li>
                                
                          </ul>
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <ul>
                                 <li className="timelist">4:30 PM to 6:15 PM</li>
                                 <li className="timelist">6:45 PM to 7:20 PM</li>
                                </ul>
                      </div>
                    </div>  
                    <div className="timedate">
                        <h5>20.10.2025 (തിരുവല്ലക്കം, ബ്രഹ്മകലശം)</h5>
                       </div>
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                            <ul>
                                <li className="timelist">3:30 AM to 4:45 AM</li>
                                <li className="timelist">After 10:30 AM</li>
                                
                          </ul>
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <ul>
                                 <li className="timelist">4:30 PM to 6:15 PM</li>
                                 <li className="timelist">6:45 PM to 7:20 PM</li>
                                </ul>
                      </div>
                    </div> 
                    <div className="timedate">
                        <h5>21.10.2025 (1 -ാം ഉത്സവം തൃക്കൊടിയേററ്) (സിംഹാസന വാഹനം)</h5>
                       </div>
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                            <ul>
                                <li className="timelist">3:30 AM to 4:45 AM</li>
                                <li className="timelist">6:30 AM to 7:00 AM</li>
                                 <li className="timelist">8:30 AM to 8:45 AM</li>
                                <li className="timelist">After 10:30 AM</li>
                                
                          </ul>
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <ul>
                                 <li className="timelist">4:30 PM to 6:00 PM</li>
                                </ul>
                      </div>
                    </div>  
                    <div className="timedate">
                        <h5>22.10.2025  (2 -ാം ഉത്‌സവം) (അനന്ത വാഹനം)</h5>
                       </div>
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                            <ul>
                                <li className="timelist">3:30 AM to 4:45 AM</li>
                                <li className="timelist">6:30 AM to 7:00 AM</li>
                                <li className="timelist">After 10:30 AM</li>
                                
                          </ul>
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <ul>
                                 <li className="timelist">5:30 PM to 6:00 PM</li>
                               </ul>
                      </div>
                    </div>  
                    <div className="timedate">
                        <h5>23.10.2025 (3  -ാം ഉത്സവം) (കമല വാഹനം)</h5>
                       </div>
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                            <ul>
                                <li className="timelist">3:30 AM to 4:45 AM</li>
                                <li className="timelist">6:30 AM to 7:00 AM</li>
                                <li className="timelist">After 10:30 AM</li>
                                
                          </ul>
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <ul>
                                 <li className="timelist">5:30 PM to 6:00 PM</li>
                               </ul>
                      </div>
                    </div> 
                    <div className="timedate">
                        <h5>24.10.2025 (4 -ാം ഉത്‌സവം) (പല്ലക്ക് വാഹനം)</h5>
                       </div>
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                            <ul>
                                <li className="timelist">3:30 AM to 4:45 AM</li>
                                <li className="timelist">6:30 AM to 7:00 AM</li>
                                <li className="timelist">After 10:30 AM</li>
                                
                          </ul>
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <ul>
                                 <li className="timelist">5:30 PM to 6:00 PM</li>
                               </ul>
                      </div>
                    </div> 
                    <div className="timedate">
                        <h5>25.10.2025 (5 -ാം ഉത്സവം) (ഗരുഡ വാഹനം)</h5>
                       </div>
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                            <ul>
                                <li className="timelist">3:30 AM to 4:45 AM</li>
                                <li className="timelist">6:30 AM to 7:00 AM</li>
                                <li className="timelist">After 10:30 AM</li>
                                
                          </ul>
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <ul>
                                 <li className="timelist">5:30 PM to 6:00 PM</li>
                               </ul>
                      </div>
                    </div> 
                    <div className="timedate">
                        <h5>26.10.2025 (6 -ാം ഉത്സവം) (ഇന്ദ്ര വാഹനം)</h5>
                       </div>
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                            <ul>
                                <li className="timelist">3:30 AM to 4:45 AM</li>
                                <li className="timelist">6:30 AM to 7:00 AM</li>
                                <li className="timelist">After 10:30 AM</li>
                                
                          </ul>
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <ul>
                                 <li className="timelist">5:30 PM to 6:00 PM</li>
                               </ul>
                      </div>
                    </div> 
                    <div className="timedate">
                        <h5>27.10.2025 (7 -ാം ഉത്‌സവം) (പല്ലക്ക് വാഹനം)</h5>
                       </div>
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                            <ul>
                                <li className="timelist">3:30 AM to 4:45 AM</li>
                                <li className="timelist">6:30 AM to 7:00 AM</li>
                                <li className="timelist">After 10:30 AM</li>
                                
                          </ul>
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <ul>
                                 <li className="timelist">5:30 PM to 6:00 PM</li>
                               </ul>
                      </div>
                    </div> 
                    <div className="timedate">
                        <h5>28.10.2025 (8 -ാം ഉത്സവം) (ഗരുഡ വാഹനം)</h5>
                       </div>
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                            <ul>
                                <li className="timelist">3:30 AM to 4:45 AM</li>
                                <li className="timelist">6:30 AM to 7:00 AM</li>
                                <li className="timelist">After 10:30 AM</li>
                                
                          </ul>
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <ul>
                                 <li className="timelist">5:30 PM to 6:00 PM</li>
                               </ul>
                      </div>
                    </div> 
                    <div className="timedate">
                        <h5>29.10.2025 (9 -ാം ഉത്സവം & പളളിവേട്ട) (ഗരുഡ വാഹനം)</h5>
                       </div>
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                            <ul>
                                <li className="timelist">3:30 AM to 4:45 AM</li>
                                <li className="timelist">6:30 AM to 7:00 AM</li>
                                <li className="timelist">After 10:30 AM</li>
                                
                          </ul>
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <ul>
                                 <li className="timelist">5:30 PM to 5:45 PM</li>
                               </ul>
                      </div>
                    </div> 
                    <div className="timedate">
                        <h5>30.10.2025 (10 -ാം ഉത്സവം & തിരു ആറാട്ട് (ഗരുഡ വാഹനം)</h5>
                       </div>
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                            <ul>
                                <li className="timelist">5:15 AM to 6:00 AM</li>
                                <li className="timelist">8:30 AM to 10:00 AM</li>
                          </ul>
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <ul>
                                 <li className="timelist">വൈകുന്നേരം ദർശനം ഇല്ല</li>
                               </ul>
                      </div>
                    </div> 
                    <div className="timedate">
                        <h5>31.10.2025 (ആറാട്ട് കലശം)</h5>
                       </div>
                    <div class="row col-md-12">
                        <div className="col-md-6 " style={{padding:'10px'}}>
                        <h3 className="heading">Morning</h3>
                            <ul>
                                <li className="timelist">3:30 AM to 4:45 AM</li>
                                <li className="timelist">6:30 AM to 7:00 AM</li>
                                <li className="timelist">After 10:30 AM</li>
                                
                          </ul>
                         </div>
                        <div className="col-md-6 " style={{padding:'10px'}}> 
                            <h3 className="heading">Evening</h3>
                                <ul>
                                 <li className="timelist">4:30 PM to 6:00 PM</li>
                               </ul>
                      </div>
                    </div>  */}

                    {/* <div style={{marginTop:'150px'}}>
                      
                      <button className="btn btn-primary" onClick={() => window.open("./timing/Alpashi_festival.pdf", "_blank")}   style={{background:'maroon'}}>Click here to see the Temple Timing</button>
                    </div> */}
                </div>
                
                
           </div> 
                      
        </div>
        
        
      </div>
    </div>
  );
}

export default Timing;